const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5334px",
    height: "3205px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00cbf7",
    d: "M 2660.5,804.5 C 2660.5,892.5 2660.5,980.5 2660.5,1068.5C 2616.19,1107.14 2571.86,1145.8 2527.5,1184.5C 2527.5,1061.5 2527.5,938.5 2527.5,815.5C 2571.54,808.358 2615.87,804.691 2660.5,804.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00c4f6",
    d: "M 2660.5,804.5 C 2698.29,804.261 2735.96,806.261 2773.5,810.5C 2773.5,920.5 2773.5,1030.5 2773.5,1140.5C 2741.2,1112.04 2709.04,1083.37 2677,1054.5C 2671.63,1059.38 2666.13,1064.04 2660.5,1068.5C 2660.5,980.5 2660.5,892.5 2660.5,804.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00bef5",
    d: "M 2773.5,810.5 C 2811.8,815.493 2849.47,823.16 2886.5,833.5C 2886.83,969.668 2886.5,1105.67 2885.5,1241.5C 2847.75,1208.29 2810.41,1174.63 2773.5,1140.5C 2773.5,1030.5 2773.5,920.5 2773.5,810.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00d1f8",
    d: "M 2527.5,815.5 C 2527.5,938.5 2527.5,1061.5 2527.5,1184.5C 2490.4,1217.87 2452.74,1250.54 2414.5,1282.5C 2414.5,1135.83 2414.5,989.167 2414.5,842.5C 2451.51,830.832 2489.17,821.832 2527.5,815.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00b8f4",
    d: "M 2886.5,833.5 C 2925.44,843.146 2963.11,856.146 2999.5,872.5C 2999.5,972.5 2999.5,1072.5 2999.5,1172.5C 2999.5,1218.17 2999.5,1263.83 2999.5,1309.5C 2999.5,1316.83 2999.5,1324.17 2999.5,1331.5C 2999.81,1335.37 2999.48,1339.04 2998.5,1342.5C 2960.51,1309.18 2922.84,1275.51 2885.5,1241.5C 2886.5,1105.67 2886.83,969.668 2886.5,833.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00d4f8",
    d: "M 2414.5,842.5 C 2414.5,989.167 2414.5,1135.83 2414.5,1282.5C 2410.78,1287.19 2406.44,1291.19 2401.5,1294.5C 2401.5,1145.17 2401.5,995.833 2401.5,846.5C 2405.83,845.167 2410.17,843.833 2414.5,842.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00d7f9",
    d: "M 2401.5,846.5 C 2401.5,995.833 2401.5,1145.17 2401.5,1294.5C 2368.19,1323.47 2334.86,1352.47 2301.5,1381.5C 2301.5,1216.5 2301.5,1051.5 2301.5,886.5C 2333.95,871.015 2367.29,857.682 2401.5,846.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#00b4f4",
    d: "M 2999.5,872.5 C 3013.37,877.435 3026.7,883.435 3039.5,890.5C 3039.5,984.5 3039.5,1078.5 3039.5,1172.5C 3026.17,1172.5 3012.83,1172.5 2999.5,1172.5C 2999.5,1072.5 2999.5,972.5 2999.5,872.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00ddfa",
    d: "M 2301.5,886.5 C 2301.5,1051.5 2301.5,1216.5 2301.5,1381.5C 2264.15,1414.84 2226.49,1447.84 2188.5,1480.5C 2188.5,1304.5 2188.5,1128.5 2188.5,952.5C 2224,927.235 2261.66,905.235 2301.5,886.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#00b0f2",
    d: "M 3039.5,890.5 C 3069.64,905.064 3098.64,921.397 3126.5,939.5C 3126.83,1112 3126.5,1284.33 3125.5,1456.5C 3082.94,1418.72 3040.6,1380.72 2998.5,1342.5C 2999.48,1339.04 2999.81,1335.37 2999.5,1331.5C 3036.79,1362.29 3073.96,1393.29 3111,1424.5C 3111.5,1417.17 3111.67,1409.84 3111.5,1402.5C 3111.5,1325.83 3111.5,1249.17 3111.5,1172.5C 3087.5,1172.5 3063.5,1172.5 3039.5,1172.5C 3039.5,1078.5 3039.5,984.5 3039.5,890.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00abf2",
    d: "M 3126.5,939.5 C 3166.76,965.086 3204.42,994.086 3239.5,1026.5C 3239.83,1203.67 3239.5,1380.67 3238.5,1557.5C 3200.51,1524.18 3162.84,1490.51 3125.5,1456.5C 3126.5,1284.33 3126.83,1112 3126.5,939.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00e3fc",
    d: "M 2188.5,952.5 C 2188.5,1128.5 2188.5,1304.5 2188.5,1480.5C 2154.33,1510.5 2120,1540.33 2085.5,1570C 2084.66,1571.01 2084.33,1572.18 2084.5,1573.5C 2084.33,1580.51 2084.5,1587.51 2085,1594.5C 2106.78,1624.15 2134.28,1630.65 2167.5,1614C 2174.36,1610.41 2181.02,1606.57 2187.5,1602.5C 2188.5,1852.67 2188.83,2103 2188.5,2353.5C 2140.06,2321.42 2095.73,2284.09 2055.5,2241.5C 2055.5,1849.17 2055.5,1456.83 2055.5,1064.5C 2095.73,1021.91 2140.06,984.578 2188.5,952.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00a5f1",
    d: "M 3239.5,1026.5 C 3281.93,1064.91 3319.6,1107.24 3352.5,1153.5C 3352.5,1486.5 3352.5,1819.5 3352.5,2152.5C 3319.88,2198.8 3282.21,2240.8 3239.5,2278.5C 3239.5,2053.83 3239.5,1829.17 3239.5,1604.5C 3241.55,1602.45 3243.22,1600.11 3244.5,1597.5C 3246.47,1595.57 3247.97,1593.24 3249,1590.5C 3249.5,1583.51 3249.67,1576.51 3249.5,1569.5C 3245.91,1565.57 3242.25,1561.57 3238.5,1557.5C 3239.5,1380.67 3239.83,1203.67 3239.5,1026.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0070c9",
    d: "M 2773.5,1140.5 C 2810.41,1174.63 2847.75,1208.29 2885.5,1241.5C 2922.84,1275.51 2960.51,1309.18 2998.5,1342.5C 3040.6,1380.72 3082.94,1418.72 3125.5,1456.5C 3162.84,1490.51 3200.51,1524.18 3238.5,1557.5C 3242.25,1561.57 3245.91,1565.57 3249.5,1569.5C 3247.85,1572.13 3246.18,1574.8 3244.5,1577.5C 3227.87,1596.88 3207.2,1603.04 3182.5,1596C 3162.3,1590.39 3143.63,1581.72 3126.5,1570C 2976.05,1438.06 2826.05,1305.56 2676.5,1172.5C 2514.65,1308.19 2352.65,1443.69 2190.5,1579C 2173.48,1591.51 2154.48,1599.01 2133.5,1601.5C 2122.94,1601.61 2113.27,1598.78 2104.5,1593C 2097.3,1586.97 2090.64,1580.47 2084.5,1573.5C 2084.33,1572.18 2084.66,1571.01 2085.5,1570C 2120,1540.33 2154.33,1510.5 2188.5,1480.5C 2226.49,1447.84 2264.15,1414.84 2301.5,1381.5C 2334.86,1352.47 2368.19,1323.47 2401.5,1294.5C 2406.44,1291.19 2410.78,1287.19 2414.5,1282.5C 2452.74,1250.54 2490.4,1217.87 2527.5,1184.5C 2571.86,1145.8 2616.19,1107.14 2660.5,1068.5C 2666.13,1064.04 2671.63,1059.38 2677,1054.5C 2709.04,1083.37 2741.2,1112.04 2773.5,1140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#00eafd",
    d: "M 2055.5,1064.5 C 2055.5,1456.83 2055.5,1849.17 2055.5,2241.5C 2012.1,2196.78 1974.43,2147.78 1942.5,2094.5C 1942.5,1800.17 1942.5,1505.83 1942.5,1211.5C 1974.43,1158.22 2012.1,1109.22 2055.5,1064.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#009ff0",
    d: "M 3352.5,1153.5 C 3400.82,1218.45 3438.48,1289.45 3465.5,1366.5C 3465.5,1557.5 3465.5,1748.5 3465.5,1939.5C 3438.47,2016.58 3400.8,2087.58 3352.5,2152.5C 3352.5,1819.5 3352.5,1486.5 3352.5,1153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0070c9",
    d: "M 2999.5,1172.5 C 3012.83,1172.5 3026.17,1172.5 3039.5,1172.5C 3063.5,1172.5 3087.5,1172.5 3111.5,1172.5C 3111.5,1249.17 3111.5,1325.83 3111.5,1402.5C 3073.83,1371.98 3036.5,1340.98 2999.5,1309.5C 2999.5,1263.83 2999.5,1218.17 2999.5,1172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#505152",
    d: "M 3244.5,1577.5 C 3244.5,1584.17 3244.5,1590.83 3244.5,1597.5C 3243.22,1600.11 3241.55,1602.45 3239.5,1604.5C 3226.64,1616.75 3211.31,1621.92 3193.5,1620C 3169.88,1614.41 3147.88,1605.25 3127.5,1592.5C 3098.53,1567.2 3069.53,1541.86 3040.5,1516.5C 3027.44,1503.8 3013.77,1491.8 2999.5,1480.5C 2962.45,1446.45 2924.79,1413.12 2886.5,1380.5C 2849.16,1346.49 2811.49,1312.82 2773.5,1279.5C 2741.73,1251.57 2710.06,1223.4 2678.5,1195C 2676.71,1194.48 2675.04,1194.81 2673.5,1196C 2668.64,1200.03 2663.97,1204.2 2659.5,1208.5C 2614.85,1245.15 2570.52,1282.15 2526.5,1319.5C 2488.52,1350.82 2450.85,1382.49 2413.5,1414.5C 2375.48,1446.2 2337.48,1477.86 2299.5,1509.5C 2262.14,1540.53 2224.81,1571.53 2187.5,1602.5C 2181.02,1606.57 2174.36,1610.41 2167.5,1614C 2134.28,1630.65 2106.78,1624.15 2085,1594.5C 2084.5,1587.51 2084.33,1580.51 2084.5,1573.5C 2090.64,1580.47 2097.3,1586.97 2104.5,1593C 2113.27,1598.78 2122.94,1601.61 2133.5,1601.5C 2154.48,1599.01 2173.48,1591.51 2190.5,1579C 2352.65,1443.69 2514.65,1308.19 2676.5,1172.5C 2826.05,1305.56 2976.05,1438.06 3126.5,1570C 3143.63,1581.72 3162.3,1590.39 3182.5,1596C 3207.2,1603.04 3227.87,1596.88 3244.5,1577.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00c3f5",
    d: "M 2773.5,1279.5 C 2773.5,1291.5 2773.5,1303.5 2773.5,1315.5C 2740.39,1286.9 2707.39,1258.06 2674.5,1229C 2673.09,1228.68 2671.76,1229.02 2670.5,1230C 2667.32,1233.08 2663.99,1235.91 2660.5,1238.5C 2660.83,1228.32 2660.49,1218.32 2659.5,1208.5C 2663.97,1204.2 2668.64,1200.03 2673.5,1196C 2675.04,1194.81 2676.71,1194.48 2678.5,1195C 2710.06,1223.4 2741.73,1251.57 2773.5,1279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01c9f6",
    d: "M 2659.5,1208.5 C 2660.49,1218.32 2660.83,1228.32 2660.5,1238.5C 2616.39,1275.39 2572.06,1312.06 2527.5,1348.5C 2527.83,1338.65 2527.49,1328.99 2526.5,1319.5C 2570.52,1282.15 2614.85,1245.15 2659.5,1208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#00f0fe",
    d: "M 1942.5,1211.5 C 1942.5,1505.83 1942.5,1800.17 1942.5,2094.5C 1884.32,2000.32 1846.66,1898.32 1829.5,1788.5C 1829.5,1697.83 1829.5,1607.17 1829.5,1516.5C 1846.86,1407.06 1884.53,1305.39 1942.5,1211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0070c9",
    d: "M 2773.5,1315.5 C 2810.21,1349.21 2847.55,1382.21 2885.5,1414.5C 2923.18,1448.18 2961.18,1481.51 2999.5,1514.5C 3012.18,1526.51 3025.18,1538.18 3038.5,1549.5C 3051.77,1560.93 3064.94,1572.6 3078,1584.5C 3078.83,1741.87 3078.66,1899.21 3077.5,2056.5C 3077.26,2062.56 3075.26,2067.9 3071.5,2072.5C 3068.3,2075.94 3064.3,2078.1 3059.5,2079C 3054.56,2080.09 3049.56,2080.75 3044.5,2081C 2950.17,2081.5 2855.83,2081.67 2761.5,2081.5C 2761.5,2000.17 2761.5,1918.83 2761.5,1837.5C 2761.5,1830.5 2761.5,1823.5 2761.5,1816.5C 2696.67,1815.5 2631.67,1815.17 2566.5,1815.5C 2566.5,1904.17 2566.5,1992.83 2566.5,2081.5C 2464.5,2081.67 2362.5,2081.5 2260.5,2081C 2250.21,2078.88 2244.21,2072.71 2242.5,2062.5C 2242.17,1903.17 2242.5,1743.83 2243.5,1584.5C 2262.86,1568.49 2282.2,1552.49 2301.5,1536.5C 2339.19,1505.14 2376.86,1473.8 2414.5,1442.5C 2452.39,1411.39 2490.06,1380.06 2527.5,1348.5C 2572.06,1312.06 2616.39,1275.39 2660.5,1238.5C 2663.99,1235.91 2667.32,1233.08 2670.5,1230C 2671.76,1229.02 2673.09,1228.68 2674.5,1229C 2707.39,1258.06 2740.39,1286.9 2773.5,1315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00bdf4",
    d: "M 2773.5,1279.5 C 2811.49,1312.82 2849.16,1346.49 2886.5,1380.5C 2886.83,1392.01 2886.49,1403.35 2885.5,1414.5C 2847.55,1382.21 2810.21,1349.21 2773.5,1315.5C 2773.5,1303.5 2773.5,1291.5 2773.5,1279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#505152",
    d: "M 2999.5,1309.5 C 3036.5,1340.98 3073.83,1371.98 3111.5,1402.5C 3111.67,1409.84 3111.5,1417.17 3111,1424.5C 3073.96,1393.29 3036.79,1362.29 2999.5,1331.5C 2999.5,1324.17 2999.5,1316.83 2999.5,1309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d0f7",
    d: "M 2526.5,1319.5 C 2527.49,1328.99 2527.83,1338.65 2527.5,1348.5C 2490.06,1380.06 2452.39,1411.39 2414.5,1442.5C 2414.83,1432.99 2414.49,1423.65 2413.5,1414.5C 2450.85,1382.49 2488.52,1350.82 2526.5,1319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#009bef",
    d: "M 3465.5,1366.5 C 3507.72,1484.26 3523.22,1605.59 3512,1730.5C 3505.6,1802.34 3490.1,1872 3465.5,1939.5C 3465.5,1748.5 3465.5,1557.5 3465.5,1366.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00b7f3",
    d: "M 2886.5,1380.5 C 2924.79,1413.12 2962.45,1446.45 2999.5,1480.5C 2999.5,1491.83 2999.5,1503.17 2999.5,1514.5C 2961.18,1481.51 2923.18,1448.18 2885.5,1414.5C 2886.49,1403.35 2886.83,1392.01 2886.5,1380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d6f8",
    d: "M 2413.5,1414.5 C 2414.49,1423.65 2414.83,1432.99 2414.5,1442.5C 2376.86,1473.8 2339.19,1505.14 2301.5,1536.5C 2302.14,1527.1 2301.47,1518.1 2299.5,1509.5C 2337.48,1477.86 2375.48,1446.2 2413.5,1414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00b3f3",
    d: "M 2999.5,1480.5 C 3013.77,1491.8 3027.44,1503.8 3040.5,1516.5C 3039.83,1527.5 3039.17,1538.5 3038.5,1549.5C 3025.18,1538.18 3012.18,1526.51 2999.5,1514.5C 2999.5,1503.17 2999.5,1491.83 2999.5,1480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00ddfa",
    d: "M 2299.5,1509.5 C 2301.47,1518.1 2302.14,1527.1 2301.5,1536.5C 2282.2,1552.49 2262.86,1568.49 2243.5,1584.5C 2242.5,1743.83 2242.17,1903.17 2242.5,2062.5C 2242.32,2070.87 2242.82,2079.21 2244,2087.5C 2247.83,2098.51 2255.66,2103.68 2267.5,2103C 2278.83,2103.5 2290.16,2103.67 2301.5,2103.5C 2301.5,2208.83 2301.5,2314.17 2301.5,2419.5C 2261.73,2400.66 2224.07,2378.66 2188.5,2353.5C 2188.83,2103 2188.5,1852.67 2187.5,1602.5C 2224.81,1571.53 2262.14,1540.53 2299.5,1509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#00f4fe",
    d: "M 1829.5,1516.5 C 1829.5,1607.17 1829.5,1697.83 1829.5,1788.5C 1818.27,1720.67 1815.44,1652.34 1821,1583.5C 1822.71,1560.88 1825.55,1538.55 1829.5,1516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00b0f2",
    d: "M 3040.5,1516.5 C 3069.53,1541.86 3098.53,1567.2 3127.5,1592.5C 3126.5,1850.33 3126.17,2108.33 3126.5,2366.5C 3098.6,2384.62 3069.6,2400.95 3039.5,2415.5C 3039.5,2311.5 3039.5,2207.5 3039.5,2103.5C 3041.41,2103.78 3043.08,2103.45 3044.5,2102.5C 3051.29,2102.03 3057.95,2100.86 3064.5,2099C 3067.79,2097.53 3070.45,2095.37 3072.5,2092.5C 3074.86,2089.29 3076.36,2085.62 3077,2081.5C 3078.53,2073.03 3078.7,2064.7 3077.5,2056.5C 3078.66,1899.21 3078.83,1741.87 3078,1584.5C 3064.94,1572.6 3051.77,1560.93 3038.5,1549.5C 3039.17,1538.5 3039.83,1527.5 3040.5,1516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808587",
    d: "M 3249.5,1569.5 C 3249.67,1576.51 3249.5,1583.51 3249,1590.5C 3247.97,1593.24 3246.47,1595.57 3244.5,1597.5C 3244.5,1590.83 3244.5,1584.17 3244.5,1577.5C 3246.18,1574.8 3247.85,1572.13 3249.5,1569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00abf2",
    d: "M 3127.5,1592.5 C 3147.88,1605.25 3169.88,1614.41 3193.5,1620C 3211.31,1621.92 3226.64,1616.75 3239.5,1604.5C 3239.5,1829.17 3239.5,2053.83 3239.5,2278.5C 3204.72,2311.62 3167.05,2340.96 3126.5,2366.5C 3126.17,2108.33 3126.5,1850.33 3127.5,1592.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#505151",
    d: "M 2761.5,1816.5 C 2761.5,1823.5 2761.5,1830.5 2761.5,1837.5C 2696.83,1837.5 2632.17,1837.5 2567.5,1837.5C 2567.5,1830.5 2567.5,1823.5 2567.5,1816.5C 2632.17,1816.5 2696.83,1816.5 2761.5,1816.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a82c9",
    d: "M 2761.5,1816.5 C 2696.83,1816.5 2632.17,1816.5 2567.5,1816.5C 2567.5,1823.5 2567.5,1830.5 2567.5,1837.5C 2567.5,1837.83 2567.5,1838.17 2567.5,1838.5C 2567.5,1919.5 2567.5,2000.5 2567.5,2081.5C 2567.17,2081.5 2566.83,2081.5 2566.5,2081.5C 2566.5,1992.83 2566.5,1904.17 2566.5,1815.5C 2631.67,1815.17 2696.67,1815.5 2761.5,1816.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00caf7",
    d: "M 2567.5,1838.5 C 2598.5,1838.5 2629.5,1838.5 2660.5,1838.5C 2660.5,2059.5 2660.5,2280.5 2660.5,2501.5C 2615.89,2501.09 2571.56,2497.42 2527.5,2490.5C 2527.5,2361.5 2527.5,2232.5 2527.5,2103.5C 2540.83,2103.5 2554.17,2103.5 2567.5,2103.5C 2567.5,2096.17 2567.5,2088.83 2567.5,2081.5C 2567.5,2000.5 2567.5,1919.5 2567.5,1838.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00c4f6",
    d: "M 2567.5,1838.5 C 2567.5,1838.17 2567.5,1837.83 2567.5,1837.5C 2632.17,1837.5 2696.83,1837.5 2761.5,1837.5C 2761.5,1918.83 2761.5,2000.17 2761.5,2081.5C 2761.5,2088.5 2761.5,2095.5 2761.5,2102.5C 2765.3,2103.48 2769.3,2103.82 2773.5,2103.5C 2773.5,2233.83 2773.5,2364.17 2773.5,2494.5C 2736.15,2499.58 2698.49,2501.92 2660.5,2501.5C 2660.5,2280.5 2660.5,2059.5 2660.5,1838.5C 2629.5,1838.5 2598.5,1838.5 2567.5,1838.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#80898e",
    d: "M 3077.5,2056.5 C 3078.7,2064.7 3078.53,2073.03 3077,2081.5C 3076.36,2085.62 3074.86,2089.29 3072.5,2092.5C 3072.82,2085.65 3072.49,2078.98 3071.5,2072.5C 3075.26,2067.9 3077.26,2062.56 3077.5,2056.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#505151",
    d: "M 2242.5,2062.5 C 2244.21,2072.71 2250.21,2078.88 2260.5,2081C 2362.5,2081.5 2464.5,2081.67 2566.5,2081.5C 2566.5,2088.5 2566.5,2095.5 2566.5,2102.5C 2547.99,2102.17 2529.66,2102.5 2511.5,2103.5C 2479.17,2103.5 2446.83,2103.5 2414.5,2103.5C 2410.17,2103.5 2405.83,2103.5 2401.5,2103.5C 2368.17,2103.5 2334.83,2103.5 2301.5,2103.5C 2290.16,2103.67 2278.83,2103.5 2267.5,2103C 2255.66,2103.68 2247.83,2098.51 2244,2087.5C 2242.82,2079.21 2242.32,2070.87 2242.5,2062.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#505151",
    d: "M 3071.5,2072.5 C 3072.49,2078.98 3072.82,2085.65 3072.5,2092.5C 3070.45,2095.37 3067.79,2097.53 3064.5,2099C 3057.95,2100.86 3051.29,2102.03 3044.5,2102.5C 3034.17,2102.5 3023.83,2102.5 3013.5,2102.5C 2964.5,2102.5 2915.5,2102.5 2866.5,2102.5C 2831.5,2102.5 2796.5,2102.5 2761.5,2102.5C 2761.5,2095.5 2761.5,2088.5 2761.5,2081.5C 2855.83,2081.67 2950.17,2081.5 3044.5,2081C 3049.56,2080.75 3054.56,2080.09 3059.5,2079C 3064.3,2078.1 3068.3,2075.94 3071.5,2072.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c8698",
    d: "M 2566.5,2081.5 C 2566.83,2081.5 2567.17,2081.5 2567.5,2081.5C 2567.5,2088.83 2567.5,2096.17 2567.5,2103.5C 2554.17,2103.5 2540.83,2103.5 2527.5,2103.5C 2522.17,2103.5 2516.83,2103.5 2511.5,2103.5C 2529.66,2102.5 2547.99,2102.17 2566.5,2102.5C 2566.5,2095.5 2566.5,2088.5 2566.5,2081.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#00d7fa",
    d: "M 2301.5,2103.5 C 2334.83,2103.5 2368.17,2103.5 2401.5,2103.5C 2401.5,2222.17 2401.5,2340.83 2401.5,2459.5C 2367.45,2447.93 2334.12,2434.6 2301.5,2419.5C 2301.5,2314.17 2301.5,2208.83 2301.5,2103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00d5f9",
    d: "M 2401.5,2103.5 C 2405.83,2103.5 2410.17,2103.5 2414.5,2103.5C 2414.5,2223.5 2414.5,2343.5 2414.5,2463.5C 2410.17,2462.17 2405.83,2460.83 2401.5,2459.5C 2401.5,2340.83 2401.5,2222.17 2401.5,2103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00d1f8",
    d: "M 2414.5,2103.5 C 2446.83,2103.5 2479.17,2103.5 2511.5,2103.5C 2516.83,2103.5 2522.17,2103.5 2527.5,2103.5C 2527.5,2232.5 2527.5,2361.5 2527.5,2490.5C 2489.28,2483.86 2451.62,2474.86 2414.5,2463.5C 2414.5,2343.5 2414.5,2223.5 2414.5,2103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00bef5",
    d: "M 2761.5,2102.5 C 2796.5,2102.5 2831.5,2102.5 2866.5,2102.5C 2872.98,2103.49 2879.65,2103.82 2886.5,2103.5C 2886.5,2226.5 2886.5,2349.5 2886.5,2472.5C 2849.55,2482.89 2811.88,2490.22 2773.5,2494.5C 2773.5,2364.17 2773.5,2233.83 2773.5,2103.5C 2769.3,2103.82 2765.3,2103.48 2761.5,2102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#00b8f4",
    d: "M 2866.5,2102.5 C 2915.5,2102.5 2964.5,2102.5 3013.5,2102.5C 3009.03,2103.49 3004.36,2103.82 2999.5,2103.5C 2999.5,2213.5 2999.5,2323.5 2999.5,2433.5C 2963.11,2449.85 2925.45,2462.85 2886.5,2472.5C 2886.5,2349.5 2886.5,2226.5 2886.5,2103.5C 2879.65,2103.82 2872.98,2103.49 2866.5,2102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#00b4f3",
    d: "M 3013.5,2102.5 C 3023.83,2102.5 3034.17,2102.5 3044.5,2102.5C 3043.08,2103.45 3041.41,2103.78 3039.5,2103.5C 3039.5,2207.5 3039.5,2311.5 3039.5,2415.5C 3026.42,2422.08 3013.09,2428.08 2999.5,2433.5C 2999.5,2323.5 2999.5,2213.5 2999.5,2103.5C 3004.36,2103.82 3009.03,2103.49 3013.5,2102.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a08443421f7b3ec720a7f35562e390de.svg";
export { ForwardRef as ReactComponent };